import { useRef, useEffect, useState } from "react";
import { memo } from "react";
import '../../shared/css/mapbox.css'
import "../curation/css/CurationMap.css"
import { MapPopup } from '../../shared/components/map/MapPopup';
import CurationListItem from "../../shared/components/curationitem/CurationListItem";
import MapCurationListItem from "../../shared/components/curationitem/MapCurationListItem";
import { AnalyticsEvent } from "../../shared/analytics/AnalyticsEvent";
import { sendAction } from "../../shared/utils/AnalyticsUtils";
import { useCurationMapContentContext, useCurationMapContext, useCurationMapHoverContext } from "./CurationMapContext";
import { useCurationPlacesContext } from "./CurationPlacesContext";

const MOBILE_SIZE = 768
const mapboxgl = require('mapbox-gl/dist/mapbox-gl.js');
mapboxgl.accessToken = 'pk.eyJ1IjoiamV5ZWUiLCJhIjoiY2xwaHNrcDI0MGJkZzJsbWhpbmgxanhvMyJ9.jscbtyYNweIFs_Bzy998Ow';

export const CurationMap = memo(function CurationMap({ isDesktop, mapId, mapMarkerEmoji, analytics, handlePopupItemClick, handlePopupItemNavigateClick,onToggleBackToListClick, onFilterButtonClick, onSearchButtonClick }) {
    const mapRef = useRef()
    const mapCurationItemRef = useRef(null)
    const mapBottomContentRef = useRef()
    const listButtonRef = useRef()
    const [popupContent, setPopupContent] = useState(null)
    const [bottomPopupContent, setBottomPopupContent] = useState(null)
    const [currentMap, setCurrentMap] = useState(null)
    const [isMapLoaded, setIsMapLoaded] = useState(false)
    const {curationMapConfig, setCurationMapConfig} = useCurationMapContext()
    const {curationMapPopup, setCurationMapPopup} = useCurationMapContentContext()
    const {placesData, setPlacesData} = useCurationPlacesContext()
    const {curationHoverId, setCurationHoverId} = useCurationMapHoverContext()
    const [hoverMarker, setHoverMarker] = useState(null)
    const [toastMessage, setToastMessage] = useState(null)
    const currentMapMarkers = useRef([])

    const geolocate = new mapboxgl.GeolocateControl({
        positionOptions: {
            enableHighAccuracy: true
        },
        trackUserLocation: true,
        showUserHeading: true
    });

    useEffect(() => {
        console.log("map ref is rendered")
        let mapStyle
        if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
            mapStyle = 'mapbox://styles/mapbox/dark-v11'
        } else {
            mapStyle = 'mapbox://styles/mapbox/light-v11'
        }
        const map = new mapboxgl.Map({
            container: 'map-container',
            style: mapStyle,
        });
        map.addControl(
            geolocate,
            "top-right"
        )
    
        map.on('render', function () {
            map.resize();
        });
        map.on('load', function() {
          setCurrentMap(map);
          updateMapMarkers(map, placesData.places.slice().reverse())
          setIsMapLoaded(true)
          if (curationMapPopup && curationMapPopup.isBottom) {
            setBottomPopupContent(curationMapPopup)
          } else {
            setPopupContent(curationMapPopup)
          }
        })
        map.on('moveend', () => {
            console.log(`move end`)
            const mapCenter = map.getCenter()
            console.log(`on map drag end ${mapCenter}`);
            setCurationMapConfig(
                {
                    center: mapCenter,
                    zoom: map.getZoom()
                }
            )
        })
        map.on('zoomend', () => {
            const mapCenter = map.getCenter()
            setCurationMapConfig(
                {
                    center: mapCenter,
                    zoom: map.getZoom()
                }
            )
            console.log(`on map zoom end ${mapCenter}`);
            console.log(`on map zoom end ${map.getZoom()}`);
            if (map.getZoom() < 16) {
                document.querySelectorAll('.marker').forEach(marker => {
                    marker.classList.remove('map-marker-big');
                    marker.classList.add('map-marker-small');
                });
            } else {
                document.querySelectorAll('.map-marker-small').forEach(marker => {
                    marker.classList.remove('map-marker-small');
                    marker.classList.add('map-marker-big');
                });
            }
        }) 
        
        window.onpopstate = e => {
            console.log(`on pop item ${window.location.href}`)
            if (!window.location.href.includes("#item")) {
                setBottomPopupContent(null);
                setCurationMapPopup(null);
                currentMapMarkers.current.forEach((marker) => {
                    // marker.getElement().style.backgroundColor = 'transparent';
                    deselectMapMarker(marker.getElement())
                });
                setPopupContent(null)
            }
        }
        geolocate.on('error', (e) => {
            console.log('Geolocation error:', e);
            console.log('Error code:', e.code);
            console.log('Error message:', e.message);
            
            // Handle different error types
            if (e.code === 1) {
                setToastMessage('Location access denied. Please enable location permissions.')
                document.getElementById("generic-message-modal").showModal()
            } else if (e.code === 2) {
                setToastMessage('Location unavailable. Please check your device settings.')
                document.getElementById("generic-message-modal").showModal()
            } else if (e.code === 3) {
                setToastMessage('Location request timed out. Please try again.')
                document.getElementById("generic-message-modal").showModal()
            }
        });
    }, [mapRef]);

    useEffect(() => {
        if (isDesktop) {
            currentMapMarkers.current.forEach((marker) => {
                if (marker.getElement().dataset.placeId == curationHoverId) {
                    selectMapMarker(marker.getElement())
                } else {
                    deselectMapMarker(marker.getElement())
                }
            })
        }
    }, [curationHoverId])

    useEffect(() => {
        
        if (!isDesktop) {
            const { offsetTop } = mapBottomContentRef.current
            console.log(`bottom popup ${JSON.stringify(bottomPopupContent)}`)  
            if (currentMap && bottomPopupContent) {
                // resetMapBounds(
                //     placesData.places.map((place) => [place.coordinates.longitude, place.coordinates.latitude]),
                //     currentMap,
                //     window.innerHeight - offsetTop,
                // )
                currentMap.easeTo({
                    center: [bottomPopupContent.placeDetails.coordinates.longitude,bottomPopupContent.placeDetails.coordinates.latitude],
                    // zoom: currentMap.getZoom(),
                    padding: {bottom: window.innerHeight - offsetTop + 32},
                    // duration: 500,
                })
            }
        }
    }, [bottomPopupContent])


    function selectMapMarker(element) {
        switch (element.dataset.markerType) {
            case 'DEFAULT':
                // element.classList.add('bg-primary');
                element.style.backgroundColor = 'hsl(var(--p) / 0.7)';
                element.classList.add('z-20')
                // if (isUsingDarkMode) {
                //     element.style.backgroundColor = "rgba(255,255,255,0.5)";
                // } else {
                //     element.style.backgroundColor = "rgba(255,183,129,0.5)";
                // }
                break;
            case 'EMOJI':
                element.style.backgroundColor = 'hsl(var(--p) / 0.7)';
                element.classList.add('z-20')
                // if (isUsingDarkMode) {
                //     element.style.backgroundColor = "rgba(255,255,255,0.5)";
                // } else {
                //     element.style.backgroundColor = "rgba(255,183,129,0.5)";
                // }
                break;
            case 'IMAGE_FIT':
                break;
            case 'IMAGE_CIRCLE':
                element.classList.remove('border-white');
                element.classList.add('border-2', 'border-primary');
                break;
        }
    }

    function deselectMapMarker(element) {
        element.style.backgroundColor = 'transparent';
        element.classList.remove('border-primary');
        element.classList.add('border-white');
        element.classList.remove('z-20')
    }

    function getSpecialEffectClass(markerEffectType) {
        switch (markerEffectType) {
            case 'WIGGLE':
                return 'animate-wiggle animate-infinite animate-ease-in-out';
            case 'PULSE':
                return 'animate-pulse animate-infinite animate-ease-in-out';
            case 'BOUNCE':
                return 'animate-bounce animate-infinite animate-ease-in-out';
            case 'NONE':
                return '';
        }
    }

    function generateMarkerElement(placeId, markerType, placeMarkerEmoji, placeMarkerUrl, markerEffectType, isSelected) {
        const el = document.createElement('div');
        el.className = `marker map-marker-small character-outline`;
        el.style.display = 'inline-block'; // Allow el to shrink-wrap to content
        el.style.width = 'auto'; // Remove any default width constraints
        el.dataset.markerType = markerType;
        el.dataset.placeId = placeId;

        switch (markerType) {
            case 'DEFAULT':
                const innerEl = document.createElement('div');
                innerEl.innerHTML = mapMarkerEmoji;
                innerEl.classList = getSpecialEffectClass(markerEffectType);
                innerEl.dataset.markerType = markerType;
                innerEl.dataset.placeId = placeId;
                el.appendChild(innerEl);
                // el.innerHTML = mapMarkerEmoji;
                break;
            case 'EMOJI':
                const emojiInnerEl = document.createElement('div');
                emojiInnerEl.innerHTML = placeMarkerEmoji || mapMarkerEmoji;
                emojiInnerEl.classList = getSpecialEffectClass(markerEffectType);
                emojiInnerEl.dataset.markerType = markerType;
                emojiInnerEl.dataset.placeId = placeId;
                el.appendChild(emojiInnerEl);
                // el.innerHTML = placeMarkerEmoji || mapMarkerEmoji;
                break;
            case 'IMAGE_FIT':
                if (placeMarkerUrl) {
                    el.className = 'marker bg-base-100';
                    el.style.backgroundImage = `url(${placeMarkerUrl})`;
                    el.style.borderRadius = '100%';
                    el.style.backgroundSize = 'cover';
                    el.style.backgroundPosition = 'center';
                    el.style.backgroundRepeat = 'no-repeat';
                } else {
                    el.innerHTML = mapMarkerEmoji;
                }
                break;
            case 'IMAGE_CIRCLE':
                if (placeMarkerUrl) {
                    el.className = 'marker bg-base-100 border-2 border-white';
                    el.style.backgroundImage = `url(${placeMarkerUrl})`;
                    el.style.borderRadius = '100%';
                    el.style.backgroundSize = 'cover';
                    el.style.backgroundPosition = 'center';
                    el.style.backgroundRepeat = 'no-repeat';
                } else {
                    el.innerHTML = mapMarkerEmoji;
                }
                break;
        }
        if (isSelected) {
            let isUsingDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches
            if (isUsingDarkMode) {
                el.style.backgroundColor = "rgba(255,255,255,0.7)";
            } else {
                el.style.backgroundColor = "rgba(255,183,129,0.7)";
            }
        }
        return el;
    }
    function updateMapMarkers(map, placeList) {
        console.log(`updating markers with list size ${placeList.length}`)
        currentMapMarkers.current.forEach((marker) => {
          marker.remove()
        });
        const geoFeatures = placeList.map((place) => {
            let image
            if (place.images && place.images.length > 0) {
            image = place.images[0].url
            } else {
            image = null
            }
            return {
            'type': 'Feature',
            'geometry': {
                'type': 'Point',
                'coordinates': [place.coordinates.longitude, place.coordinates.latitude]
            },
            'properties': {
                'title': place.title,
                'id': place.id,
                'image': image,
                'description': place.mainComment != null ? place.mainComment.text : null,
                'url': `/places/${place.id}`,
            },
            'markerType': place.markerType,
            'markerEmoji': place.markerEmoji,
            'markerUrl': place.markerUrl,
            'placeId': place.id,
            'placeEmoji': place.emoji,
            'markerEffectType': place.markerEffectType
            }
        });
        const geojson = {
            'type': 'FeatureCollection',
            'features': geoFeatures
        };


        for (const feature of geojson.features) {
            const el = generateMarkerElement(
                feature.placeId,
                feature.markerType, 
                feature.markerEmoji, 
                feature.markerUrl,
                feature.markerEffectType,
                curationMapPopup && curationMapPopup.placeDetails.id == feature.placeId,
                false
            )
            const marker = new mapboxgl.Marker(el)
            .setLngLat(feature.geometry.coordinates)
            .addTo(map);
            currentMapMarkers.current.push(marker);
        }

        if (geoFeatures.length > 0) {
            const coordinates = geojson.features.map((feature) => feature .geometry.coordinates)
            resetMapBounds(coordinates, map, 0)
            if (curationMapConfig) {
                map.easeTo({
                    center: [curationMapConfig.center.lng, curationMapConfig.center.lat],
                    zoom: curationMapConfig.zoom,
                    duration: 0,
                })
            }
        }
        
        map.on("click", (e) => {
            const target = e.originalEvent.target;
            console.log(`target ${JSON.stringify(target)}`)
            const matchedMarker = currentMapMarkers.current.find((marker) => target.dataset.placeId == marker.getElement().dataset.placeId)
            if (matchedMarker) {
                const markerPlaceDetails = placesData.places.slice().reverse()[currentMapMarkers.current.indexOf(matchedMarker)];
                sendAction(analytics, AnalyticsEvent.MAP_MARKER_CLICK, AnalyticsEvent.CURATION_MAP_VIEW, {
                    placeId: markerPlaceDetails.id,
                    collectionId: mapId
                });

                if (isDesktop) {
                    currentMapMarkers.current.forEach((marker) => {
                        // marker.getElement().style.backgroundColor = 'transparent';
                        deselectMapMarker(marker.getElement())
                    });
                    selectMapMarker(matchedMarker.getElement())
                    
                    setCurationMapPopup(
                        {
                            placeDetails: markerPlaceDetails,
                            coordinates: matchedMarker._lngLat,
                            isBottom: false
                        }
                    )
                    setPopupContent(
                        {
                            placeDetails: markerPlaceDetails,
                            coordinates: matchedMarker._lngLat
                        }
                    );
                } else {
                    currentMapMarkers.current.forEach((marker) => {
                        if (target.dataset.placeId == marker.getElement().dataset.placeId) {
                            console.log(`marker type ${JSON.stringify(marker.getElement().dataset.markerType)}`)
                            selectMapMarker(marker.getElement())

                        } else {
                            console.log(`marker classlist ${JSON.stringify(marker.getElement().classList)}`)
                            // marker.getElement().style.backgroundColor = 'transparent';
                            deselectMapMarker(marker.getElement())
                        }
                    });
                    
                    console.log(matchedMarker.getElement())
                    // onMarkerTapOnMobile(markerPlaceDetails)
                    console.log(markerPlaceDetails)
                    setCurationMapPopup(
                        {
                            placeDetails: markerPlaceDetails,
                            coordinates: matchedMarker._lngLat,
                            isBottom: true
                        }
                    )
                    setBottomPopupContent(
                        {
                            placeDetails: markerPlaceDetails
                        }
                    );
                }

            } else {
                currentMapMarkers.current.forEach((marker) => {
                    // marker.getElement().style.backgroundColor = 'transparent';
                    deselectMapMarker(marker.getElement())
                });
                setBottomPopupContent(null);
                setCurationMapPopup(null);
            }
        });
    }

    function resetMapBounds(coordinates, map, mapBottomExtraPadding) {
        // console.log(`bottom extra padding ${mapBottomExtraPadding} ${JSON.stringify(coordinates)}`)
        var bounds = coordinates.reduce(function(bounds, coord) {
        return bounds.extend(coord);
        }, new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]))
        const padding = {
            top: 10,
            left: 50,
            right: 50,
            bottom: mapBottomExtraPadding + 50
        }

        map.fitBounds(
            bounds, {
                maxZoom: 16,
                padding: padding,
                duration: 0
            }
        )
        console.log(`map center after reset bounds: ${map.getCenter()}`)
        setCurationMapConfig(
            {
                center: map.getCenter(), zoom: map.getZoom()
            }
        )
    }

    return (
        <div className="relative w-full h-full">
        <div ref={mapRef} className={`col-span-1 h-full max-h-screen ${ isMapLoaded ? "" : "blur-lg" }`} id='map-container'></div>
        {popupContent && currentMap && <MapPopup 
            shouldDisableClick={placesData.places.length == 0}
            map={currentMap} 
            placeDetails={popupContent} 
            onPopupClick={handlePopupItemClick}
            analytics={analytics}
            onNavigateClick={handlePopupItemNavigateClick}
            />
        }
        {
            
        }
        {
            !isDesktop && <div ref={mapBottomContentRef} className={`fixed ${bottomPopupContent ? "bottom-2": "bottom-4"} right-4 left-4 z-10`}>
                <div className='w-full bg-transparent text-right' ref={listButtonRef}>
                {/* <button className="btn md:btn-lg text-base btn-accent normal-case rounded-full mr-1" onClick={() => { onFilterButtonClick() }}>
                <svg className='w-5 h-5' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path className='stroke-accent-content' d="M19 3H5C3.58579 3 2.87868 3 2.43934 3.4122C2 3.8244 2 4.48782 2 5.81466V6.50448C2 7.54232 2 8.06124 2.2596 8.49142C2.5192 8.9216 2.99347 9.18858 3.94202 9.72255L6.85504 11.3624C7.49146 11.7206 7.80967 11.8998 8.03751 12.0976C8.51199 12.5095 8.80408 12.9935 8.93644 13.5872C9 13.8722 9 14.2058 9 14.8729L9 17.5424C9 18.452 9 18.9067 9.25192 19.2613C9.50385 19.6158 9.95128 19.7907 10.8462 20.1406C12.7248 20.875 13.6641 21.2422 14.3321 20.8244C15 20.4066 15 19.4519 15 17.5424V14.8729C15 14.2058 15 13.8722 15.0636 13.5872C15.1959 12.9935 15.488 12.5095 15.9625 12.0976C16.1903 11.8998 16.5085 11.7206 17.145 11.3624L20.058 9.72255C21.0065 9.18858 21.4808 8.9216 21.7404 8.49142C22 8.06124 22 7.54232 22 6.50448V5.81466C22 4.48782 22 3.8244 21.5607 3.4122C21.1213 3 20.4142 3 19 3Z" strokeWidth="1.5"/>
                    </svg> Filter
                </button> */}
                {/* <button className="btn md:btn-lg text-base btn-secondary btn-circle normal-case rounded-full" onClick={() => { onSearchButtonClick() }}>
                <svg className='w-5 h-5 stroke-secondary-content' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.6725 16.6412L21 21M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                </button> */}
                
                <button className="btn md:btn-lg text-base btn-primary normal-case rounded-full" onClick={() => { onToggleBackToListClick() }}>
                <svg className='w-5 h-5' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path className="stroke-primary-content" d="M8 6L21 6.00078M8 12L21 12.0008M8 18L21 18.0007M3 6.5H4V5.5H3V6.5ZM3 12.5H4V11.5H3V12.5ZM3 18.5H4V17.5H3V18.5Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg> List
                </button>
                </div>
                {bottomPopupContent && currentMap && <div className="w-full pt-2">
                    <MapCurationListItem 
                    ref={mapCurationItemRef}
                    imageHeightClass="h-32"
                    placeItem={bottomPopupContent.placeDetails} 
                    clickEvent={
                        (placeItem) => {
                            console.log(`map item clicked ${JSON.stringify(placeItem)}`)
                            handlePopupItemClick(placeItem.id, placeItem)
                        }
                    }
                    onNavigateClick={handlePopupItemNavigateClick}
                    analytics={analytics}
                />
                </div>
                }
          </div>
        }
        {
            <dialog id="generic-message-modal" className="modal">
                <div className="modal-box w-11/12 max-w-5xl">
                    <p className="py-2 text-base">{toastMessage}</p>
                    <div className="modal-action">
                        <button className="btn btn-ghost" onClick={() => { document.getElementById("generic-message-modal").close()}}>Ok</button>
                    </div>
                </div>
            </dialog>
        }
        </div>
    );
    });
